export function trimNull(str) {
    return str?.trim?.() || null
}
export function trimEmpty(str) {
    return str?.trim?.() || ""
}
export function inplaceObjectMap(fields, object, f) {
    for (let field of fields) {
        object[field] = f(object[field])
    }
}
export function emptyArrayIfFalsable(arr) {
    if (!arr) return []
    return arr
}
export function intOrDefault(val, def = 0) {
    if (val === true) return 1
    if (val === false) return 0
    val = parseInt(val)
    if (isNaN(val)) return def
    if (isFinite(val)) return val
    return def
}
export function floatOrDefault(val, def = 0) {
    val = parseFloat(val)
    if (isNaN(val)) return def
    if (isFinite(val)) return val
    return def
}
export function inplaceObjectFilter(f,object){
    for(let [key,value] of Object.entries(object)){
        if(!f(key,value)) delete object[key]
    }
}
export function deleteFields(fields,object){
    inplaceObjectFilter((key, value) => !fields.includes(key), object)
}
export const intOrInvalid = (v) => v ? intOrDefault(v, "invalid value") : 0
export const floatOrInvalid = (v) => v ? floatOrDefault(v, "invalid value") : 0
